export default __webpack_public_path__ + "static/media/Maskgroup2.aaf69ed8.svg";